<ng-template
  let-observer
  [tuiDialogOptions]="{ label: 'Change client type', size: 'm' }"
  [(tuiDialog)]="open"
  (tuiDialogClose)="onDialogClose()"
>
  <p class="text-sm text-[#191C30E5] mb-3">
    Client: <strong>{{ clientLabel() }}</strong>
  </p>
  <p class="text-sm text-[#6B6D80] mb-4">
    The current account will be <strong>archived</strong> (login disabled, email
    replaced). Shifts and invoices stay on the old record. You will create a
    <strong>new</strong> client with a new ID — review type-specific fields before
    saving.
  </p>

  <label class="block text-sm font-medium text-[#3E4A58] mb-2">New client type</label>
  <tui-combo-box
    [(ngModel)]="targetType"
    [stringify]="stringifyType"
    [tuiTextfieldLabelOutside]="true"
    placeholder="Select type"
    class="w-full mb-6"
  >
    <tui-data-list-wrapper
      *tuiDataList
      [items]="targetOptions | tuiFilterByInput"
      [itemContent]="stringifyType | tuiStringifyContent"
    />
  </tui-combo-box>

  <div class="flex justify-end gap-3">
    <button
      appearance="flat"
      tuiButton
      type="button"
      [disabled]="busy"
      (click)="onCancel()"
    >
      Cancel
    </button>
    <button
      appearance="primary"
      tuiButton
      type="button"
      [disabled]="!targetType || busy"
      (click)="onConfirm()"
    >
      {{ busy ? "Archiving…" : "Archive & continue" }}
    </button>
  </div>
</ng-template>
